import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';

export default function DynamicBoxes({
  mainTitleOrange,
  mainTitleWhite,
  features = [],
}) {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 12 },
        bgcolor: '#ecf4fc',
        position: 'relative',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 8 } }}>
          <Typography 
            variant="h2"
            sx={{
              fontFamily: 'Barlow, sans-serif',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '2.8rem' },
              fontWeight: 800,
              lineHeight: 1.2,
              color: '#1a202c',
              mb: 2,
            }}
          >
            {mainTitleOrange}
            <Box
              component="span"
              sx={{
                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {` ${mainTitleWhite}`}
            </Box>
          </Typography>
        </Box>

        {/* Features Grid */}
        <Grid container spacing={2}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={feature.gridSize || 6} key={index}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 2,
                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  transition: 'all 0.3s ease',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                  },
                }}
              >
                <CardContent
                  sx={{
                    p: { xs: 2.5, md: 3 },
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: 'Barlow, sans-serif',
                      fontSize: { xs: '1.1rem', md: '1.25rem' },
                      fontWeight: 700,
                      color: '#1a202c',
                      mb: 1.5,
                      lineHeight: 1.3,
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: 'Barlow, sans-serif',
                      fontSize: { xs: '0.875rem', md: '0.95rem' },
                      color: '#4a5568',
                      lineHeight: 1.5,
                      flex: 1,
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}